import replaceMultiple from '../utils/replaceMultiple';

/**
 * Update the 'cust_params' in a VAST URL with the given key-value pairs,
 * deleting empty parameters from the completed URL.
 *
 * @param {Object} newParams New key-value pairs.
 * @param {URL} oldURL Previous VAST URL.
 * @returns {URL} Updated VAST URL.
 */
export default (newParams, oldURL) => {
  if (! Object.keys(newParams).length) {
    return new URL(oldURL.toString());
  }

  // Adds 'vpif' param to show if video player is in focus
  const tabInFocus = 'visible' === document.visibilityState;

  const newStr = replaceMultiple(
    new URLSearchParams(
      // First ensure that all keys are overwritten with new params, then filter.
      Object
        .entries(
          {
            ...Object.fromEntries(
              new URLSearchParams(
                oldURL.searchParams.get('cust_params'),
              ).entries(),
            ),
            ...newParams,
            vpif: tabInFocus.toString(),
          },
        )
        .reduce(
          // eslint-disable-next-line arrow-body-style
          ((carry, pair) => {
            return pair[1]
              ? {
                ...carry,
                [pair[0]]: pair[1],
              }
              : carry;
          }),
          {},
        ),
    ).toString(),
    // `cust_params` needs special encoding.
    {
      '=': '%3D',
      '&': '%26',
      ',': '%2C',
    },
  );

  const out = new URL(oldURL);
  out.searchParams.delete('cust_params');

  const IS_FREEWHEEL = 'freewheel' === window.nxstVideoDeliveryAdProvider;
  const IS_FREEWHEEL_AMP = IS_FREEWHEEL && window.nxstVideoDeliveryIsAmp;
  const ADD_CUST_PARAMS = ! IS_FREEWHEEL && ! IS_FREEWHEEL_AMP;

  const custParams = ADD_CUST_PARAMS ? `&cust_params=${newStr}` : '';

  return `${decodeURIComponent(out.toString())}${custParams}`;
};
